/* @generated from adl module ferovinum.app.deliveryoptions */

import * as ADL from './../../runtime/adl';
import * as ferovinum_app_db from './db';

export interface DeliveryOptionReq_InWarehouseTransfer {
  kind: 'inWarehouseTransfer';
  value: ferovinum_app_db.InWarehouseTransfer;
}
export interface DeliveryOptionReq_InWarehouseTransferWithAccountCode {
  kind: 'inWarehouseTransferWithAccountCode';
  value: ferovinum_app_db.InWarehouseTransferWithAccountCode;
}
export interface DeliveryOptionReq_OrgLocationDelivery {
  kind: 'orgLocationDelivery';
  value: ferovinum_app_db.ShippingDelivery;
}
export interface DeliveryOptionReq_ShippedDelivery {
  kind: 'shippedDelivery';
  value: ferovinum_app_db.ShippingDelivery;
}
export interface DeliveryOptionReq_ProductionOrderRunDelivery {
  kind: 'productionOrderRunDelivery';
  value: ferovinum_app_db.ProductionOrderRunDelivery;
}
export interface DeliveryOptionReq_ProductionOrderLossDelivery {
  kind: 'productionOrderLossDelivery';
  value: ferovinum_app_db.ProductionOrderLossDelivery;
}
export interface DeliveryOptionReq_NewDealRequestLossDelivery {
  kind: 'newDealRequestLossDelivery';
  value: ferovinum_app_db.NewDealRequestLossDelivery;
}
export interface DeliveryOptionReq_PurchaseRequest {
  kind: 'purchaseRequest';
  value: ferovinum_app_db.PurchaseRequestInWarehouseTransfer;
}

export type DeliveryOptionReq = DeliveryOptionReq_InWarehouseTransfer | DeliveryOptionReq_InWarehouseTransferWithAccountCode | DeliveryOptionReq_OrgLocationDelivery | DeliveryOptionReq_ShippedDelivery | DeliveryOptionReq_ProductionOrderRunDelivery | DeliveryOptionReq_ProductionOrderLossDelivery | DeliveryOptionReq_NewDealRequestLossDelivery | DeliveryOptionReq_PurchaseRequest;

export interface DeliveryOptionReqOpts {
  inWarehouseTransfer: ferovinum_app_db.InWarehouseTransfer;
  inWarehouseTransferWithAccountCode: ferovinum_app_db.InWarehouseTransferWithAccountCode;
  orgLocationDelivery: ferovinum_app_db.ShippingDelivery;
  shippedDelivery: ferovinum_app_db.ShippingDelivery;
  productionOrderRunDelivery: ferovinum_app_db.ProductionOrderRunDelivery;
  productionOrderLossDelivery: ferovinum_app_db.ProductionOrderLossDelivery;
  newDealRequestLossDelivery: ferovinum_app_db.NewDealRequestLossDelivery;
  purchaseRequest: ferovinum_app_db.PurchaseRequestInWarehouseTransfer;
}

export function makeDeliveryOptionReq<K extends keyof DeliveryOptionReqOpts>(kind: K, value: DeliveryOptionReqOpts[K]) { return {kind, value}; }

const DeliveryOptionReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.deliveryoptions","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"inWarehouseTransfer","default":{"kind":"nothing"},"name":"inWarehouseTransfer","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"InWarehouseTransfer"}},"parameters":[]}},{"annotations":[],"serializedName":"inWarehouseTransferWithAccountCode","default":{"kind":"nothing"},"name":"inWarehouseTransferWithAccountCode","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"InWarehouseTransferWithAccountCode"}},"parameters":[]}},{"annotations":[],"serializedName":"orgLocationDelivery","default":{"kind":"nothing"},"name":"orgLocationDelivery","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ShippingDelivery"}},"parameters":[]}},{"annotations":[],"serializedName":"shippedDelivery","default":{"kind":"nothing"},"name":"shippedDelivery","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ShippingDelivery"}},"parameters":[]}},{"annotations":[],"serializedName":"productionOrderRunDelivery","default":{"kind":"nothing"},"name":"productionOrderRunDelivery","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductionOrderRunDelivery"}},"parameters":[]}},{"annotations":[],"serializedName":"productionOrderLossDelivery","default":{"kind":"nothing"},"name":"productionOrderLossDelivery","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductionOrderLossDelivery"}},"parameters":[]}},{"annotations":[],"serializedName":"newDealRequestLossDelivery","default":{"kind":"nothing"},"name":"newDealRequestLossDelivery","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NewDealRequestLossDelivery"}},"parameters":[]}},{"annotations":[],"serializedName":"purchaseRequest","default":{"kind":"nothing"},"name":"purchaseRequest","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"PurchaseRequestInWarehouseTransfer"}},"parameters":[]}}]}},"name":"DeliveryOptionReq","version":{"kind":"nothing"}}};

export const snDeliveryOptionReq: ADL.ScopedName = {moduleName:"ferovinum.app.deliveryoptions", name:"DeliveryOptionReq"};

export function texprDeliveryOptionReq(): ADL.ATypeExpr<DeliveryOptionReq> {
  return {value : {typeRef : {kind: "reference", value : snDeliveryOptionReq}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.app.deliveryoptions.DeliveryOptionReq" : DeliveryOptionReq_AST
};
